import React, { FunctionComponent } from "react"

interface Source {
  eventKey: string
  title: string
  icon?: string
}

interface SourceListProps {
  list: Source[]
  sourceListHeader?: string
  onSelect?: (source: Source) => void
}

export const SourceList: FunctionComponent<SourceListProps> = ({ list, sourceListHeader, onSelect }) => {
  return (
    <div className="photoselector-sourcelist">
      {sourceListHeader ? <div className="photoselector-sourcelist-header">{sourceListHeader}</div> : null}
      {list.map((source) => (
        <div
          key={source.eventKey}
          className="photoselector-sourcelist-item"
          data-tam={source.eventKey}
          onClick={() => (onSelect ? onSelect(source) : null)}
        >
          {source.icon && <img src={source.icon} className="photoselector-navigation-logo" />}
          <div className="photoselector-sourcelist-title">{source.title}</div>
        </div>
      ))}
    </div>
  )
}
